import { Component, OnInit, Input, Output, EventEmitter, SecurityContext } from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser'
import { SelectItem } from 'primeng/api/selectitem';
import { ContenusService } from 'src/app/services/contenus.service';

@Component({
  selector: 'app-reseaux-sociaux',
  templateUrl: './reseaux-sociaux.component.html',
  styleUrls: ['./reseaux-sociaux.component.css'],
})
export class ReseauxSociauxComponent implements OnInit {

  disabled: boolean;
  validName: string;
  duplicateName: string;
  douteName: string;
  
  cqName: string;
  errors: SelectItem[] = [];
  motifs: Object[] = [];
  motifsCq : Object[] = [];
  ContenusAnterieurs : Object[] = [];
  selectedErrors : Object[] = [];

  @Input('id-moderation') idModeration : string;
  @Input('numero-contenu') numContenu : string;
  @Input('id-contenu') idContenu : number; //=> vue qu'il y en a beaucoup il faut avoir l'id du contenu pour assigner la valeur correctement 
  @Input('lien') lien : string;
  @Input('is-site') site : boolean = false;
  @Input('cq') cq: boolean = false;
  @Input('valide') valid: boolean = false;
  @Input('duplicate') duplicate: boolean = false;
  @Input('read-only') readonly: boolean = false;
  @Input('valide-cq') validationCQ: boolean = null;
  @Input("erreurs-cq") inputErreursCq : Object[] = [];
  @Input('erreurs') inputErreurs : Object[] = [];
  @Input('doute') isDoute : boolean = false;
  @Input('attente-doute') attenteDoute : boolean = false;
  @Input('is-retour') isRetour : boolean = false;

  @Output() validChangedEvent = new EventEmitter<Object>();
  @Output() linkChangedEvent = new EventEmitter<Object>();
  @Output() erreursChangedEvent = new EventEmitter<Object>();
  @Output() validCqChangedEvent = new EventEmitter<Object>();
  @Output() erreursCqChangedEvent = new EventEmitter<Object>();
  @Output() douteEvent = new EventEmitter<Object>();


  constructor( private contenuService: ContenusService) { }

  ngOnInit(): void {
    let typeTraitement = (this.cq === true) ? 1 : 0;

    if(this.site) {
      this.contenuService.recupererListeMotifs(2, typeTraitement).subscribe(results => {
        if(results["status"] !== "success"){
          console.log("Une erreur dans la requête:" + results["cause"]);
        }else {
          let input = results["data"];
          this.initErrors(input);
        }

        if(this.inputErreurs !== null && this.inputErreurs !== undefined) this.motifs = this.inputErreurs;
        if(this.inputErreursCq !== null && this.inputErreursCq !== undefined) this.motifsCq = this.inputErreursCq;
        this.selectedErrors = this.motifs;
      });
    }else {
      this.contenuService.recupererListeMotifs(5, typeTraitement).subscribe(results => {
        if(results["status"] !== "success"){
          console.log("Une erreur dans la requête:" + results["cause"]);
        }else {
          let input = results["data"];
          this.initErrors(input);
        }
        
        if(this.inputErreurs !== null && this.inputErreurs !== undefined) this.motifs = this.inputErreurs;
        if(this.inputErreursCq !== null && this.inputErreursCq !== undefined) this.motifsCq = this.inputErreursCq;
        this.selectedErrors = this.motifs;
      });
    }

    let optionsForEtatsAnterieurs = {
      idModeration : this.idModeration,
      numContenu : this.numContenu
    }

    this.contenuService.recupererEtatsAnterieurs(optionsForEtatsAnterieurs).subscribe(results => {
      if(results["status"] !== "success"){
        console.log("Une erreur dans la requête:" + results["cause"]);
      }else {
        let listeContenus = results["data"];
        listeContenus.forEach(current => {
          this.ContenusAnterieurs.push(current);
        });
      }
    });


    this.disabled = true;
    this.validName = this.generateRandomString();
    this.duplicateName = this.generateRandomString();
    this.cqName = this.generateRandomString();
    this.douteName = this.generateRandomString();
  }

  /**
   * 
   * @param input 
   * met les erreurs entrées en input pour les mettre dans la liste
   */
  initErrors(input) {
    input.forEach(current => {
      let motif = {
        label : current["designation_motif"],
        value : current
      };
      this.errors.push(motif);
    });
  }

  /**
   * Utilisé pour créer des identifiants uniques aux radios
   */
  generateRandomString (length=6){
    return Math.random().toString(20).substr(2, length)
  }

  /**
   * Le lien est éditable ou non
   */
  setEditable() {
    this.disabled = !this.disabled;
  }

  /**
   * @param valid
   * Emet la valeur de OK ou KO du contenu à chaque changement
   */
  validChanged(valid: boolean) {
    let sortie = {
      id_contenu : this.idContenu,
      is_valid: valid
    }
    if(valid) {
      this.motifs = [];
      this.setErrors(this.motifs);
    }
    this.validChangedEvent.emit(sortie);
  }

  validCqChanged(valid : boolean) {
    let sortie = {
      id_contenu : this.idContenu,
      is_valid : valid
    }
    if(valid) {
      this.motifsCq = [];
      this.setCqErrors(this.motifsCq);
    }
    this.validCqChangedEvent.emit(sortie);
  }

  /**
   * 
   * @param link 
   * Emet la valeur du lien à chaque changement
   */
  linkChanged(link: string) {
    let sortie = {
      id_contenu : this.idContenu,
      lien : link
    }
    this.linkChangedEvent.emit(sortie);
  }

  /**
   * Permet d'ouvrir le lien dans un nouvel onglet
   */
  openLinkOnNewTab(link = this.lien ){
    if (!link.match(/^https?:\/\//i)) {
        link = 'http://' + link;
    }
    var url = encodeURI(link);
    console.log(url);
    window.open(url, "_blank");
  }

  /**
   * @param errors
   * met à jour les motifs d'erreurs à chaque changement
   */
  setErrors(errors: Object[]) {
    let sortie = {
      id_contenu : this.idContenu,
      erreurs : errors
    }
    this.motifs = errors;
    this.erreursChangedEvent.emit(sortie);
  }

  /**
   * @param errors
   * met à jour les motifs d'erreurs de cq à chaque changement
   */
  setCqErrors(errors: Object[]) {
    let sortie = {
      id_contenu : this.idContenu,
      erreurs : errors
    }

    this.motifsCq = errors;
    this.erreursCqChangedEvent.emit(sortie);
  }


  /**
   * Fonction qui envoie les données du contenu en cas de doute
   */
  doute(doute: boolean) {
    console.log(this.douteName)
    if(doute) {
      this.valid = null;
      this.validChanged(null);
      this.duplicate = false;
      this.setErrors([]);
    }

    let type = (this.site) ? 'site' : 'reseaux';

    let options = {
      doute : doute,
      numContenu : this.numContenu,
      type  : type
    };

    this.douteEvent.emit(options);
  }



  disableModeration() { //valeur de disabled 
    if(this.attenteDoute) {
      return false;
    }

    if(this.readonly || this.isDoute || this.cq) {
      return true;
    }

    return false;
  }
  

  disableDoute() {
    if(this.attenteDoute) {
      return false;
    }

    if(this.readonly || this.cq) {
      return true;
    }
  }
}
